/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Card,
  Table,
  Button,
  Space,
  Input,
  Popconfirm,
  Tag,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { getAPI, postAPI, displayMessage } from "../../utils/common";
import { SUCCESS_MESSAGE, ERROR_MSG_TYPE } from "../../constants/messages";
import {
  KITCHEN_PURCHASE_LIST,
  KITCHEN_PURCHASE_DELETE,
} from "../../constants/api";
import LS_SERVICE from "../../utils/localStorage";

function KitchenPurchaseTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);

    const successFn = (res) => {
      if (res.status === true) {
        const formatted = res.data.map((row, index) => {
          const userType = LS_SERVICE.get("user_type");

          const isSuperAdmin = userType === "superAdmin";
          const isAdmin = userType === "admin";

          const canDelete =
            isSuperAdmin ||
            (isAdmin && dayjs().diff(dayjs(row.created_at), "minute") <= 60);

          const showDelete = isSuperAdmin || isAdmin;
          return {
            key: index,
            ID: index + 1,
            Date: dayjs(row.purchase_date).format("DD MMM YYYY"),
            Supplier: row.supplier_name,
            Total: `₹ ${row.total_amount}`,
            Items: row.items?.length || 0,
            CreatedDate: dayjs(row.created_at).format("DD MMM YYYY hh:mm:ss A"),
            Action: (
              <Space>
                <Button
                  size="small"
                  onClick={() => navigate("/kitchen/purchase/view/" + row.id)}
                >
                  View
                </Button>

                {showDelete && (
                  <Popconfirm
                    title="Delete Purchase"
                    description="This will reverse stock. Continue?"
                    onConfirm={() => deleteData(row.id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button size="small" danger disabled={!canDelete}>
                      Delete
                    </Button>
                  </Popconfirm>
                )}
              </Space>
            ),
          };
        });

        setState(formatted);
        setFilteredState(formatted);
      } else {
        setState([]);
        setFilteredState([]);
      }
      setLoading(false);
    };

    const errorFn = () => {
      setLoading(false);
      setState([]);
      setFilteredState([]);
    };

    getAPI(KITCHEN_PURCHASE_LIST, successFn, errorFn, {});
  };

  const deleteData = (id) => {
    setLoading(true);

    const successFn = (res) => {
      if (res.status === true) {
        displayMessage(SUCCESS_MESSAGE, res.message);
        getList();
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, res.message);
      }
    };

    const errorFn = () => {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to delete purchase");
    };

    postAPI(KITCHEN_PURCHASE_DELETE, { id }, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = state.filter((row) =>
      row.Supplier.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredState(filtered);
  };

  const columns = [
    { title: "S.No", dataIndex: "ID", width: 60 },
    { title: "Purchase Date", dataIndex: "Date", width: 150 },
    { title: "Supplier", dataIndex: "Supplier", width: 150 },
    { title: "Items", dataIndex: "Items", width: 100 },
    { title: "Total Amount", dataIndex: "Total", width: 150 },
    { title: "Created On", dataIndex: "CreatedDate", width: 150 },
    { title: "Action", dataIndex: "Action", width: 180 },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Store Purchases"
          bordered
          extra={
            <Space>
              <Input
                placeholder="Search by supplier"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 250 }}
              />
              <Button
                type="primary"
                onClick={() => navigate("/kitchen/purchase/add")}
              >
                Add Purchase <PlusOutlined />
              </Button>
            </Space>
          }
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState}
            pagination={{ pageSize: 10 }}
            scroll={{ x: 900 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default KitchenPurchaseTable;
